import styled from 'styled-components'
import { SearchNumber } from './SearchNumber'

export const StyledSearchNumber = styled(SearchNumber)`
  && .padding {
    padding: 24px;
  }
`
